export default __webpack_public_path__ + "locales/pl/SocialAuthWelcomeDialog.json?hash=a84841311e02e8226b31d4b586c52a0c";